import { gridContainer } from 'components/library/CardStyles.bs';
import { Card_t } from 'models/Models.gen';
import dynamic from 'next/dynamic';

type CardProps = {
  card: Card_t;
  inGrid?: boolean;
  position: number;
};

// @ts-ignore
const RemoteSkuTile = dynamic(() => import('consumer_woc/components/SkuTile'), {
  loading: () => <span></span>,
  ssr: false,
});

const SkuTileContainer = dynamic(
  () =>
    // @ts-ignore using HeroBannerContainer from consumer_woc to provide theme to SkuTile as it does the stuff we want. TODO: Fix this, consumer-ui to be it's own MFE
    import('consumer_woc/components/HeroBanner').then(m => m.HeroBannerContainer),
  { ssr: false }
);

const Card = ({ card: { themes, promos, tagline, displayName, slug }, inGrid = true }: CardProps) => {
  const href = `/store/${slug}/`;
  const imgSrc = themes?.[0]?.image;
  const hasPromos = promos?.some(promo => promo.enabled);
  const tags = tagline ? [tagline] : [];
  const title = displayName;

  return (
    <div className={inGrid ? gridContainer : ''}>
      {/* @ts-ignore */}
      <SkuTileContainer>
        <RemoteSkuTile
          // @ts-ignore
          title={title}
          imgSrc={imgSrc}
          imgAlt={title}
          href={href}
          ribbon={hasPromos}
          tags={tags}
          height="100%"
        />
      </SkuTileContainer>
    </div>
  );
};

export default Card;
